import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "../../mock";
import { useAuth } from "../../context/AuthContext";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const nav = useNavigate();

  return (
    <header className="w-full sticky top-0 z-40 bg-white/90 backdrop-blur border-b border-cream">
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img className="logo-b" src="/logo-b.png" alt="Full Bench" />
          <span className="font-display text-xl">Full Bench</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.href}
              to={l.href}
              className={({ isActive }) =>
                `text-sm link-underline ${isActive ? "text-coral" : "text-[#2E2E2E]"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <button onClick={() => nav("/app")} className="btn-coral px-4 py-2 rounded-md text-sm font-medium">
              Open app
            </button>
          ) : (
            <>
              <Link to="/signin" className="text-sm link-underline">Sign in</Link>
              <Link to="/signup" className="btn-coral px-4 py-2 rounded-md text-sm font-medium">
                Try Full Bench free
              </Link>
            </>
          )}
        </div>

        <button className="md:hidden" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-cream bg-white">
          <div className="px-5 py-4 flex flex-col gap-3">
            {NAV_LINKS.map((l) => (
              <Link key={l.href} to={l.href} onClick={() => setOpen(false)} className="py-2">
                {l.label}
              </Link>
            ))}
            {user ? (
              <button onClick={() => nav("/app")} className="btn-coral px-4 py-2 rounded-md text-sm font-medium">
                Open app
              </button>
            ) : (
              <>
                <Link to="/signin" className="py-2">Sign in</Link>
                <Link to="/signup" className="btn-coral px-4 py-2 rounded-md text-sm font-medium text-center">
                  Try Full Bench free
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
